import React from 'react';
import Icon from '../../../components/AppIcon';

const DecisionCriteriaPanel = ({ criteria }) => {
  const getCriteriaIcon = (type) => {
    const icons = {
      financial: 'DollarSign',
      operational: 'Settings',
      market: 'TrendingUp',
      risk: 'AlertTriangle',
      timeline: 'Clock',
      resources: 'Users'
    };
    return icons?.[type] || 'CheckSquare';
  };

  const getWeightColor = (weight) => {
    if (weight >= 80) return 'text-success';
    if (weight >= 60) return 'text-primary';
    if (weight >= 40) return 'text-warning';
    return 'text-muted-foreground';
  };

  return (
    <div className="card">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center">
          <Icon name="Scale" size={24} color="var(--color-primary)" />
        </div>
        <div>
          <h3 className="text-lg font-semibold">Kriteria Keputusan</h3>
          <p className="text-sm text-muted-foreground">Bobot penilaian untuk rekomendasi</p>
        </div>
      </div>
      <div className="space-y-4">
        {criteria?.map((criterion, index) => (
          <div key={index} className="p-4 rounded-lg bg-muted/50">
            <div className="flex items-start gap-3 mb-3">
              <div className="w-10 h-10 rounded-lg bg-card flex items-center justify-center flex-shrink-0">
                <Icon name={getCriteriaIcon(criterion?.type)} size={20} color="var(--color-primary)" />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-semibold mb-1">{criterion?.name}</h4>
                <p className="text-xs text-muted-foreground line-clamp-2">
                  {criterion?.description}
                </p>
              </div>
            </div>

            <div className="flex items-center justify-between">
              <span className="text-xs text-muted-foreground">Bobot Kriteria</span>
              <div className="flex items-center gap-2">
                <div className="w-32 h-2 bg-card rounded-full overflow-hidden">
                  <div 
                    className={`h-full transition-all duration-500 ${
                      criterion?.weight >= 80 ? 'bg-success' :
                      criterion?.weight >= 60 ? 'bg-primary' :
                      criterion?.weight >= 40 ? 'bg-warning' : 'bg-muted-foreground'
                    }`}
                    style={{ width: `${criterion?.weight}%` }}
                  />
                </div>
                <span className={`text-sm font-semibold data-text ${getWeightColor(criterion?.weight)}`}>
                  {criterion?.weight}%
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="mt-6 p-4 rounded-lg bg-primary/5 border border-primary/20">
        <div className="flex items-start gap-3">
          <Icon name="Info" size={20} color="var(--color-primary)" className="flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-sm font-medium text-primary mb-1">Metodologi Penilaian</p>
            <p className="text-xs text-muted-foreground">
              Setiap kriteria dinilai berdasarkan data historis, analisis AI, dan best practices industri dairy untuk menghasilkan rekomendasi yang objektif dan terukur.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DecisionCriteriaPanel;